import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=8d45e82a&scoped=true"
import script from "./Segmentation.vue?vue&type=script&lang=js"
export * from "./Segmentation.vue?vue&type=script&lang=js"
import style0 from "./Segmentation.vue?vue&type=style&index=0&id=8d45e82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45e82a",
  null
  
)

export default component.exports